import Modal from "@/components/Modal";
import UserWorkflowDocuments from "@/lib/UserWorkflowDocuments";
import { DocumentAccessProvider } from "@/providers/DocumentAccess";
import { FC } from "react";

type Props = {
  creatorId: string;
  userWorkflowId: string;
  setCaseDocumentsModalOpen: (open: boolean) => void;
};
const CaseDocumentsModal: FC<Props> = ({ creatorId, userWorkflowId, setCaseDocumentsModalOpen }) => (
  <Modal title="Documents" drag onClose={() => setCaseDocumentsModalOpen(false)}>
    <DocumentAccessProvider>
      <UserWorkflowDocuments isModal creatorId={creatorId} userWorkflowId={userWorkflowId} isDownloadEnabled />
    </DocumentAccessProvider>
  </Modal>
);

export default CaseDocumentsModal;
